import { render, staticRenderFns } from "./ChatReview.vue?vue&type=template&id=22419f50&"
import script from "./ChatReview.vue?vue&type=script&lang=ts&"
export * from "./ChatReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports